import React from "react";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import { PaperStyled, ModalStyled, ImageStyled, CloseIconBoxStyled, HighlightOffIconStyled } from './ImageModal.styled';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const ImageModal = ({ open, handleClose, image, imageId }) => {
    return (
        <ModalStyled
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <PaperStyled elevation={2}>
                    <ImageStyled
                        src={image}
                        alt={`screenshot ${imageId}`}
                    />
                    <CloseIconBoxStyled onClick={handleClose}>
                        <HighlightOffIconStyled />
                    </CloseIconBoxStyled>
            </PaperStyled>
        </ModalStyled>
    );
};
